// document.utils.ts
export function formatDocument(value: string | null | undefined): string {
  if (!value) return '';

  // Remove caracteres não numéricos
  const doc = value.replace(/\D/g, '');
  
  // Verifica se é CPF (11 dígitos) ou CNPJ (14 dígitos)
  if (doc.length === 11) {
    // Formata como CPF: XXX.XXX.XXX-XX
    return doc.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  } else if (doc.length === 14) {
    // Formata como CNPJ: XX.XXX.XXX/XXXX-XX
    return doc.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }
  
  // Se não for nem CPF nem CNPJ, retorna o valor original sem formatação
  return doc;
}

/**
 * Remove todos os caracteres especiais de um documento (CPF/CNPJ)
 * mantendo apenas os números
 */
export function cleanDocument(value: string | null | undefined): string {
  if (!value) return '';
  return value.replace(/\D/g, '');
}

export function isCpf(value: string | null | undefined): boolean {
  if (!value) return false;
  const doc = value.replace(/\D/g, '');
  return doc.length === 11;
}

export function isCnpj(value: string | null | undefined): boolean {
  if (!value) return false;
  const doc = value.replace(/\D/g, '');
  return doc.length === 14;
}

// Função para validar CPF ou CNPJ
export function isValidDocument(value: string | null | undefined): boolean {
  if (!value) return false;
  
  const doc = value.replace(/\D/g, '');
  
  if (doc.length === 11) {
    return isValidCpf(doc);
  } else if (doc.length === 14) {
    return isValidCnpj(doc);
  }
  
  return false;
}

// Validação de CPF
function isValidCpf(cpf: string): boolean {
  // Verifica se todos os dígitos são iguais (caso inválido)
  if (/^(\d)\1+$/.test(cpf)) {
    return false;
  }
  
  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  
  let resto = soma % 11;
  let dv1 = resto < 2 ? 0 : 11 - resto;
  
  if (dv1 !== parseInt(cpf.charAt(9))) {
    return false;
  }
  
  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  
  resto = soma % 11;
  let dv2 = resto < 2 ? 0 : 11 - resto;
  
  return dv2 === parseInt(cpf.charAt(10));
}

// Validação de CNPJ
function isValidCnpj(cnpj: string): boolean {
  // Verifica se todos os dígitos são iguais (caso inválido)
  if (/^(\d)\1+$/.test(cnpj)) {
    return false;
  }
  
  // Validação do primeiro dígito verificador
  let soma = 0;
  let peso = 5;
  
  for (let i = 0; i < 12; i++) {
    soma += parseInt(cnpj.charAt(i)) * peso;
    peso = peso === 2 ? 9 : peso - 1;
  }
  
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(cnpj.charAt(12))) {
    return false;
  }
  
  // Validação do segundo dígito verificador
  soma = 0;
  peso = 6;
  
  for (let i = 0; i < 13; i++) {
    soma += parseInt(cnpj.charAt(i)) * peso;
    peso = peso === 2 ? 9 : peso - 1;
  }
  
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  return resultado === parseInt(cnpj.charAt(13));
}
